import React, { Component } from "react";
import Dropzone from "../dropzone/Dropzone";
import "./Upload.css";
import Progress from "../progress/Progress";
import SanityFileUpload from "../../utilities/SanityFileUpload";
import { Navigate } from "react-router-dom";

class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      files: [],
      uploads: [],
      uploading: false,
      uploadProgress: {},
      successfullUploaded: false,
    };

    this.onFilesAdded = this.onFilesAdded.bind(this);
    this.uploadFiles = this.uploadFiles.bind(this);
    this.sendRequest = this.sendRequest.bind(this);
    this.renderActions = this.renderActions.bind(this);
  }

  onSkip = (event) => {
    event.preventDefault();
    this.setState({ loading: false, shouldRedirect: true });
  };

  onFilesAdded(files) {
    files.forEach((file) => {
      const fileData = {
        fileObj: null,
        fileUrl: null,
      };

      fileData.fileObj = file;
      fileData.fileUrl = URL.createObjectURL(file);

      let uploadName = `${fileData.fileObj.name}-${Date.now()}`.replace(
        /\s/g,
        ""
      );

      console.log(`processing ${uploadName}`);

      let upload = new File([fileData.fileObj], uploadName);

      this.setState((prevState) => ({
        uploads: prevState.uploads.concat(upload),
      }));
    });

    this.setState((prevState) => ({
      files: prevState.files.concat(files),
    }));
  }

  uploadFiles = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    console.log("Uploading records...");
    let reviewId = localStorage.getItem("reviewId");
    this.setState({ uploadProgress: {}, uploading: true });
    const promises = [];
    this.state.uploads.forEach((upload) => {
      promises.push(
        new SanityFileUpload().appendFileToSanityArray(reviewId, upload)
      );
    });

    try {
      await Promise.all(promises);

      this.setState({ successfullUploaded: true, uploading: false });
      this.setState({ loading: false, shouldRedirect: true });
    } catch (e) {
      // Not Production ready! Do some error handling here instead...
      this.setState({ successfullUploaded: true, uploading: false });
    }
  };

  sendRequest(file) {
    return new Promise((resolve, reject) => {
      const req = new XMLHttpRequest();

      req.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const copy = { ...this.state.uploadProgress };
          copy[file.name] = {
            state: "pending",
            percentage: (event.loaded / event.total) * 100,
          };
          this.setState({ uploadProgress: copy });
        }
      });

      req.upload.addEventListener("load", (event) => {
        const copy = { ...this.state.uploadProgress };
        copy[file.name] = { state: "done", percentage: 100 };
        this.setState({ uploadProgress: copy });
        resolve(req.response);
      });

      req.upload.addEventListener("error", (event) => {
        const copy = { ...this.state.uploadProgress };
        copy[file.name] = { state: "error", percentage: 0 };
        this.setState({ uploadProgress: copy });
        reject(req.response);
      });

      const formData = new FormData();
      formData.append("file", file, file.name);

      // TODO #8 mystery upload url
      req.open("POST", "http://localhost:8000/upload");
      req.send(formData);
    });
  }

  renderProgress(file) {
    const uploadProgress = this.state.uploadProgress[file.name];
    if (this.state.uploading || this.state.successfullUploaded) {
      return (
        <div className="ProgressWrapper">
          <Progress progress={uploadProgress ? uploadProgress.percentage : 0} />
          <img
            className="CheckIcon"
            alt="done"
            src="baseline-check_circle_outline-24px.svg"
            style={{
              opacity:
                uploadProgress && uploadProgress.state === "done" ? 0.5 : 0,
            }}
          />
        </div>
      );
    }
  }

  renderActions() {
    return (
      <div>
        <button
          onClick={this.uploadFiles}
          className={
            this.state.loading
              ? "button mr-3 mb-2 is-primary is-loading"
              : "button mr-3 mb-2 is-primary"
          }
          disabled={this.state.files.length < 1}
        >
          Upload records and proceed
        </button>
        <button onClick={this.onSkip} className="button is-light">
          Skip this step
        </button>
      </div>
    );
    // if (this.state.successfullUploaded) {
    //   return (
    //     <button
    //       onClick={() =>
    //         this.setState({ files: [], successfullUploaded: false })
    //       }
    //     >
    //       Clear
    //     </button>
    //   );
    // } else {
    //   return (
    //     <button
    //       disabled={this.state.files.length < 0 || this.state.uploading}
    //       onClick={this.uploadFiles}
    //     >
    //       Upload
    //     </button>
    //   );
    // }
  }

  render() {
    return (
      <div className="Upload">
        {this.state.shouldRedirect && (
          <Navigate replace to="/terms-and-conditions" />
        )}
        <div className="Content">
          <div className="mr-4">
            <Dropzone
              onFilesAdded={this.onFilesAdded}
              disabled={this.state.uploading || this.state.successfullUploaded}
            />
          </div>
          <div className="Files">
            {this.state.files.length > 0 && (
              <div className="mb-2">Records ready to upload:</div>
            )}
            {this.state.files.map((file) => {
              return (
                <div key={file.name} className="Row">
                  <span className="Filename mr-2">{file.name}</span>
                  {/* <span className="is-underlined">Remove</span> */}
                  {/* {this.renderProgress(file)} */}
                </div>
              );
            })}
          </div>
        </div>
        <div className="Actions">{this.renderActions()}</div>
      </div>
    );
  }
}

export default Upload;
